import { ERROR_TEXTS, EVENTS } from '../lib/constants';
import { GameConfigs } from '../lib/globals/GameConfigs';

import { textManager } from '../lib/lang/TextManager';
class ErrorController {
	constructor(vc, config, msg) {
		this.t = textManager.getTranslationContext();
		this.vc = vc;
		this.configs = config;
		this.msg = msg;
		this.text =
			this.vc[this.configs.target][this.configs.item][this.configs.value];
		this.text.text = this.t(ERROR_TEXTS[GameConfigs.errors.code]);
		this.text.anchor.set(0.5, 0);
		window.addEventListener(EVENTS.ERROR_PAGE, this, false);
	}

	handleEvent(evt) {
		if (evt.detail.error) {
			this.text.text = this.t(ERROR_TEXTS[GameConfigs.errors.code]);
			window.removeEventListener(EVENTS.ERROR_PAGE, this, false);
		}
	}
}
export default ErrorController;
